
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("36IDP", function(module, exports) {

$parcel$export(module.exports, "removeFieldClauseFromJql", () => (parcelRequire("9kcYg")).default);
$parcel$export(module.exports, "getNewJqlFromDoubleClausePickerJqlData", () => (parcelRequire("ae7Qs")).default);
$parcel$export(module.exports, "replaceClause", () => (parcelRequire("l9se4")).replaceClause);
$parcel$export(module.exports, "addClause", () => (parcelRequire("4GTru")).default);
$parcel$export(module.exports, "findClauseInAst", () => (parcelRequire("bT7m3")).default);
$parcel$export(module.exports, "sanitizeClauseName", () => (parcelRequire("9olch")).sanitizeClauseName);
$parcel$export(module.exports, "JqlUtils", () => (parcelRequire("71TnQ")).JqlUtils);

var $4GTru = parcelRequire("4GTru");
var $bT7m3 = parcelRequire("bT7m3");
var $ae7Qs = parcelRequire("ae7Qs");
var $9kcYg = parcelRequire("9kcYg");
var $l9se4 = parcelRequire("l9se4");
var $9olch = parcelRequire("9olch");

var $71TnQ = parcelRequire("71TnQ");

});
parcelRegister("4GTru", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2db861c2cbae7c$export$2e2bcd8739ae039);

var $ekfiD = parcelRequire("ekfiD");
/**
 * Adds a new clause to an AST's jql.
 *
 * values that are string[] are automatically wrapped in ()
 */ const $5f2db861c2cbae7c$var$addClause = (ast, jqlClauseFn, valueOrValues)=>{
    const santizedValue = Array.isArray(valueOrValues) ? `(${valueOrValues.join(',')})` : valueOrValues;
    const jqlClause = jqlClauseFn(santizedValue);
    const jqlString = ast.represents;
    if (ast.query) {
        if (ast.query.where) {
            if (ast.query && ast.query.orderBy && ast.query.orderBy.position) {
                const [orderByStartPosition] = ast.query.orderBy.position;
                const whereClause = (0, $ekfiD.substring)(jqlString, 0, orderByStartPosition);
                const orderByClause = (0, $ekfiD.substring)(jqlString, orderByStartPosition);
                return `${whereClause}${whereClause.trim().length > 0 ? 'AND ' : ''}${jqlClause} ${orderByClause}`;
            }
            return `${jqlString}${jqlString.trim().length > 0 ? ' AND ' : ''}${jqlClause}`;
        }
        return `${jqlClause}${jqlString.trim().length > 0 ? ` ${jqlString}` : ''}`;
    }
    return jqlString;
};
var $5f2db861c2cbae7c$export$2e2bcd8739ae039 = $5f2db861c2cbae7c$var$addClause;

});

parcelRegister("ae7Qs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc55b66858e3c6a$export$2e2bcd8739ae039);

var $ehDeP = parcelRequire("ehDeP");
var $lmIUR = parcelRequire("lmIUR");
const $1dc55b66858e3c6a$var$singleDatePattern = /^(-)?[0-9]+(m|minute|minutes|h|hour|hours|d|day|days|w|week|weeks){1}$/;
const $1dc55b66858e3c6a$var$isSingleDateValue = (str)=>$1dc55b66858e3c6a$var$singleDatePattern.test(str.toLowerCase());
const $1dc55b66858e3c6a$var$wrapWithQuotesIfNeeded = (text)=>$1dc55b66858e3c6a$var$isSingleDateValue(text) ? text : `"${text.replace(/"/g, '\\"')}"`;
const $1dc55b66858e3c6a$var$getClauses = (ast, fieldIdentifier)=>{
    const fieldsToReturn = [];
    const where = ast.query?.where;
    if (where) {
        if (where.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b) && where.clauses) where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (where.clauseType === (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a)) {
            const fieldId = where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(where);
        }
    }
    return fieldsToReturn;
};
const $1dc55b66858e3c6a$var$createTerminalClause = ({ fieldId: fieldId, operator: operator, value: value })=>(0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldId), (0, $ehDeP.default).operator(operator), (0, $ehDeP.default).byText.valueOperand($1dc55b66858e3c6a$var$wrapWithQuotesIfNeeded(value)));
const $1dc55b66858e3c6a$var$appendOrReplaceClause = ({ fieldId: fieldId, newClauseData: newClauseData, clauseToReplace: clauseToReplace, query: query })=>{
    const { operator: operator, operand: value } = newClauseData;
    if (clauseToReplace) clauseToReplace.replace($1dc55b66858e3c6a$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }));
    else query.appendClause($1dc55b66858e3c6a$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
};
const $1dc55b66858e3c6a$var$appendOrReplaceClauses = ({ fieldId: fieldId, jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause, query: query })=>{
    const { primaryClause: primaryClauseData, secondaryClause: secondaryClauseData } = jqlData;
    if (primaryClauseData) $1dc55b66858e3c6a$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: primaryClauseData,
        clauseToReplace: fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
    if (secondaryClauseData) $1dc55b66858e3c6a$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: secondaryClauseData,
        clauseToReplace: primaryClauseData ? fieldToRenderSecondaryClause : fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
};
const $1dc55b66858e3c6a$var$deleteUnnecessaryClauses = ({ jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause })=>{
    if (!jqlData || !jqlData.primaryClause && !jqlData.secondaryClause) {
        fieldToRenderClause && fieldToRenderClause.remove();
        fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
    }
    if (jqlData && (!jqlData.primaryClause || !jqlData.secondaryClause)) fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
};
const $1dc55b66858e3c6a$var$getNewJqlFromDoubleClausePickerJqlData = (fieldId, ast, jqlData)=>{
    if (!ast.query) return ast.represents;
    const [fieldToRenderClause, fieldToRenderSecondaryClause] = $1dc55b66858e3c6a$var$getClauses(ast, fieldId);
    if (jqlData !== undefined) $1dc55b66858e3c6a$var$appendOrReplaceClauses({
        fieldId: fieldId,
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause,
        query: ast.query
    });
    $1dc55b66858e3c6a$var$deleteUnnecessaryClauses({
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause
    });
    return (0, $lmIUR.print)(ast, {
        operatorCase: 'upper'
    });
};
var $1dc55b66858e3c6a$export$2e2bcd8739ae039 = $1dc55b66858e3c6a$var$getNewJqlFromDoubleClausePickerJqlData;

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("l9se4", function(module, exports) {

$parcel$export(module.exports, "replaceClause", () => $ed6d138399aff707$export$189724904773d0e3);

var $ekfiD = parcelRequire("ekfiD");

var $9ibSd = parcelRequire("9ibSd");
const $ed6d138399aff707$export$189724904773d0e3 = (ast, clause, replacementJqlWithValue, unsanitizedKeywordOrWords)=>{
    const currentJql = ast.represents;
    const santizedValue = Array.isArray(unsanitizedKeywordOrWords) ? `(${unsanitizedKeywordOrWords.join(',')})` : unsanitizedKeywordOrWords;
    const position = (0, $9ibSd.getClausePosition)(currentJql, clause);
    if (position) {
        const [start, end] = position;
        return `${(0, $ekfiD.substring)(currentJql, 0, start)}${replacementJqlWithValue(santizedValue)}${(0, $ekfiD.substring)(currentJql, end)}`;
    }
    return currentJql;
};

});



//# sourceMappingURL=async-jira-jql-utils.6c4bf49a.js.map
